import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import ProductRedirect from "../../components/ProductCard/ProductRedirect";
import CustomCakeTopper from "../../pages/CustomCakeTopper/CustomCakeTopper";
import OrderProductOptions from "../../pages/Product/OrderProductOptions/OrderProductOptions";
import Product from "../../pages/Product/Product";

const ProductRoutes = () => {
  return (
    <Switch>
      <Route path="/products/single/:id" component={ProductRedirect} />
      <Route path="/products/customize/:id" component={ProductRedirect} />
      {/* Order Product Options (sleeves, cake images, etc.) */}
      <Route
        path="/products/box/:id/options/:orderProductId?"
        component={OrderProductOptions}
      />
      <Route path="/products/box/:id" component={ProductRedirect} />
      <Route path="/products/box/:id/assortment" component={ProductRedirect} />
      <Route
        path="/products/custom-cake-topper/:id/"
        component={CustomCakeTopper}
      />
      <Route path="/products/:slug/:defaultPreset?" component={Product} />
      <Redirect to="/menu" />
    </Switch>
  );
};

export default ProductRoutes;
